import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=4a2a7b80&scoped=true"
import script from "./Forbidden.vue?vue&type=script&lang=ts"
export * from "./Forbidden.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2a7b80",
  null
  
)

export default component.exports